// User layout specific JavaScript functions

function toggleDropdown(id) {
  const dropdown = document.getElementById(id);
  dropdown.classList.toggle("hidden");
}

// Close dropdown when clicking outside
document.addEventListener("click", function (event) {
  const dropdowns = document.querySelectorAll('[id$="Dropdown"]');
  dropdowns.forEach((dropdown) => {
    if (!dropdown.closest(".relative").contains(event.target)) {
      dropdown.classList.add("hidden");
    }
  });
});

// Make function globally available
window.toggleDropdown = toggleDropdown;
